import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateSubjectGroups, ISubjectGroupPayload } from "../types";
import { GetDeletedSubjectGroups, GetSubjectGroups } from "../store/thunk";

const initialState: IInitialStateSubjectGroups = {
    subjectGroups: [],
    selectedSubjectGroupsIDs: [],
    subjectGroupsRestore: [],
    isViewSubjectGroupsRestore: false,
    isLoadingSubjectGroups: true,
};

const subjectGroupsSlice = createSlice({
    name: "subjectGroups",
    initialState,
    reducers: {
        setSubjectGroups: (state, action: PayloadAction<ISubjectGroupPayload[]>) => {
            state.subjectGroups = action.payload;
        },
        deletedRestoreSubjectGroups: (state, action) => {
            state.subjectGroupsRestore = state.subjectGroupsRestore.filter(item => item.id !== action.payload);
        },
        deleteSubjectGroups: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.subjectGroups = state.subjectGroups.filter(item => item.id !== id);
        },
        setSelectedSubjectGroupsIDs: (state, action) => {
            state.selectedSubjectGroupsIDs = action.payload;
        },
        setSubjectGroupsRestore: (state, action) => {
            state.subjectGroupsRestore = action.payload;
        },
        setIsViewSubjectGroupsRestore: state => {
            state.isViewSubjectGroupsRestore = !state.isViewSubjectGroupsRestore;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetSubjectGroups.pending, state => {
                state.isLoadingSubjectGroups = true;
            })
            .addCase(GetSubjectGroups.fulfilled, state => {
                state.isLoadingSubjectGroups = false;
            })
            .addCase(GetSubjectGroups.rejected, state => {
                state.isLoadingSubjectGroups = false;
            })
            .addCase(GetDeletedSubjectGroups.pending, state => {
                state.isLoadingSubjectGroups = true;
            })
            .addCase(GetDeletedSubjectGroups.fulfilled, state => {
                state.isLoadingSubjectGroups = false;
            })
            .addCase(GetDeletedSubjectGroups.rejected, state => {
                state.isLoadingSubjectGroups = false;
            });
    },
});

export const {
    setSubjectGroups,
    deletedRestoreSubjectGroups,
    setSelectedSubjectGroupsIDs,
    deleteSubjectGroups,
    setSubjectGroupsRestore,
    setIsViewSubjectGroupsRestore,
} = subjectGroupsSlice.actions;

export default subjectGroupsSlice;
